import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

const DateTime = ({ label, left, ...props }) => {
  return (
    <div className="_spectrum-Field_36b9b _spectrum-Field--positionTop_36b9b">
      <label className="_spectrum-FieldLabel_36b9b filter-fonts">{label}</label>
      <div className="_spectrum-Textfield_61339 _spectrum-Field-field_36b9b">
        <DatePicker
          className="_spectrum-Textfield-input_61339 filter-date"
          {...props}
        />
      </div>
    </div>
  );
};

DateTime.propTypes = {
  label: PropTypes.string,
  left: PropTypes.bool,
};

DateTime.defaultProps = {
  label: 'Default Label',
  left: false,
};

export default DateTime;
